<template>
  <el-dialog destroy-on-close title="铺货到店铺" :visible.sync="visible" width="800px" @close="handleClose">
    <BulkShelvesContent
      ref="BulkShelvesContentRef"
      :smallShopItem="smallShopItem"
      :openEdit="openEdit"
      :closeEdit="closeEdit"
      :openDistribitionTool="openDistribitionTool"
      @visibleChange="visibleChange"
    ></BulkShelvesContent>
  </el-dialog>
</template>

<script>
import BulkShelvesContent from '@components/prod/center/BasicComps/BulkShelvesContent';

export default {
  components: {
    BulkShelvesContent,
  },
  props: {
    smallShopItem:Boolean,
    openEdit: Function,
    closeEdit: Function,
    openDistribitionTool: Function,
  },
  data() {
    return {
      visible: false,
    };
  },

  watch: {},
  methods: {
    visibleChange(visible) {
      this.visible = visible;
    },
    handleClose() {
      this.$refs.BulkShelvesContentRef.handleClose();
    },

    method_open(type, data, opts={}) {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.BulkShelvesContentRef.method_open(type, data, opts);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>